'use strict';
import React, { Component } from 'react';
import ColumnTitle from './ColumnTitle.jsx';

class TableHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            selectAllCheckbox: props.selectAllCheckbox
        };
        this.selectAllCheckbox = this.selectAllCheckbox.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    selectAllCheckbox() {
        this.state.selectAllCheckbox();
    }

    render() {
        let icon = false;
        let functions = this.props.data.user_functions;

        if (this.props != undefined) {
            if (this.props.data.hasOwnProperty("column")) {
                icon = this.props.data.column[this.props.data.columnIndex].state
            }
        }

        return (<thead>
            <tr>
                <th>
                    <div className="row">
                        <div className="col-xs-12">
                            <ColumnTitle
                                title="NOMBRE"
                                columnIndex={0}
                                order={(this.props.data.columnIndex == 0)}
                                icon={icon}
                                orderColumn={this.props.orderColumn} />
                        </div>
                    </div>
                </th>
                <th>
                    <ColumnTitle
                        title="MARCA"
                        columnIndex={1}
                        order={(this.props.data.columnIndex == 1)}
                        icon={icon}
                        orderColumn={this.props.orderColumn} />
                </th>
                <th>
                    <ColumnTitle
                        title="TIPO CUENTA"
                        columnIndex={2}
                        order={(this.props.data.columnIndex == 2)}
                        icon={icon}
                        orderColumn={this.props.orderColumn} />
                </th>
                <th>
                    {functions.Exportacion == true &&
                        <div className="dropdown">
                            <button className="btn btn-default" data-toggle="dropdown">Exportar</button>
                            <ul className="dropdown-menu">
                                <li>
                                    <p> <a href="#" className="list-group-item"> CSV </a> </p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item"> TSV para Excel </a></p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item"> Excel (xlsx) </a></p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item">PDF</a></p>
                                </li>
                            </ul>
                        </div>}
                </th>
            </tr>
        </thead>);
    }
}

export default TableHeader